module.exports = __webpack_public_path__ + "media/images/en-8d77f741d1084f519524dfd805e18a6b.svg";